module.exports = __webpack_public_path__ + "static/media/Dmitry_Kornev.e78be0af.jpg";